import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LeftSquareFilledSvg from "@ant-design/icons-svg/es/asn/LeftSquareFilled";
import AntdIcon from "../components/AntdIcon";
var LeftSquareFilled = function LeftSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LeftSquareFilled.displayName = 'LeftSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(LeftSquareFilled);